$(document).ready(function() {

  if ($('.accordion').length) {
    $('.accordion__btn').click(function() {
      let content = $(this).closest('.accordion__item').find('.accordion__content');
      let isActive = content.is(':visible');
      $('.accordion__content').slideUp();
      $('.accordion__btn').removeClass('accordion__btn_opened');
        
      if (!isActive) {
        content.stop(true, true).slideDown();
        $(this).addClass('accordion__btn_opened');
      }
    });
  }

  if ($('.sticky-nav').length) {
    $(window).on("scroll", function () {
      let scrollPosition = $(window).scrollTop();
  
      $(".content-section").each(function () {
        let sectionTop = $(this).offset().top;
        let sectionBottom = sectionTop + $(this).outerHeight();
  
        if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
          let currentId = $(this).attr("id");
  
          $(".sticky-nav__link").removeClass("active");
          $(".sticky-nav__link[href='#" + currentId + "']").addClass("active");
        }
      });
    });  
  }

  $('.header__btn').on('click', function(event) {
    event.stopPropagation();
    $('.nav').toggleClass('nav_opened');
    $('.header__btn').toggleClass('header__btn_opened');
  });

  $(document).on('click', function(event) {
    if (!$(event.target).closest('.header').length) {
      $('.nav').removeClass('nav_opened');
      $('.header__btn').removeClass('header__btn_opened');
    }
  });

  $(".btn").on("click", function () {
    let targetId = $(this).attr("href"); 
    sessionStorage.setItem("scrollTarget", targetId); 
  });

  let targetId = sessionStorage.getItem("scrollTarget"); 
  sessionStorage.removeItem("scrollTarget"); 

  if (targetId && targetId !== "#" && $(targetId).length) {
    let headerHeight = $(".header").outerHeight() || 0;
    let targetElement = $(targetId);

    if (targetElement.length) {
      let targetPosition = targetElement.offset().top - headerHeight;
      $("html, body").animate({ scrollTop: targetPosition }, 800);
    }
  }

  $(".form button[type='submit']").click(function (event) {
    event.preventDefault();

    let isValid = true;

    $(".error-message").remove(); 

    $(".form [required]").each(function () {
      if (!$(this).val().trim()) {
        $(this).addClass("notvalid").after("<span class='error-message'>This field is required</span>");
        isValid = false;
      }
    });

    let ageField = $("#age");
    let ageValue = ageField.val().trim();
    let ageErrorMessage = ageField.next(".error-message");

    if (!/^\d+$/.test(ageValue) || parseInt(ageValue) < 18) {
      ageField.addClass("notvalid");

      if (ageErrorMessage.length === 0) {
        ageField.after("<span class='error-message'>Age must be 18 or older</span>");
      }

      isValid = false;
    }

    let emailField = $("#email");
    let emailValue = emailField.val().trim();
    let emailErrorMessage = emailField.next(".error-message");
    let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Стандартна перевірка email

    if (!emailRegex.test(emailValue)) {
      emailField.addClass("notvalid");
      if (emailErrorMessage.length === 0) {
        emailField.after("<span class='error-message'>Enter a valid email address</span>");
      }
      isValid = false;
    }

    if (isValid) {
      $(".form__message").fadeIn();

      setTimeout(() => {
        $(".form__message").fadeOut();
        $(".form")[0].reset();
      }, 30000);
    }
  });

  $(".form [required]").on("input", function () {
    $(this).removeClass("notvalid"); 
    $(this).next(".error-message").remove(); 
  });

  $(".btn_back").click(function() {
    window.history.back();
  });
});
